"use client"

import depictClientOnlyClient from "@/lib/depict-client/depict-client-only-client-init"
import {
    CurrencyFormat,
    formatPricesInTransformedData
} from "@/lib/depict-client/helpers/formatPricesInTransformedData"
import { transformDepictProductData } from "@/lib/depict-client/helpers/transformDepictProductData"
import { SortModel } from "@/lib/depict-client/types/api/ProductListingRequestV3"
import logger from "@/lib/logger/logger-init"
import { match } from "ts-pattern"

export const getDepictProductsInListingViaExternalIdClient = async (config: {
    market: string
    locale: string
    merchant: string
    external_id?: string
    limit?: number
    page?: number
    cursor?: string | undefined
    hits_per_page?: number
    filters: any
    session_id?: string
    sort?: SortModel
    centraSessionCurrencyFormat: CurrencyFormat | undefined
}) => {
    // Fetch the price formatting data from cookies
    const currentPricelist = config.centraSessionCurrencyFormat

    const request =
        await depictClientOnlyClient.listing.getProductsInListingViaExternalId(
            config?.external_id ?? "",
            {
                market: config.market,
                locale: config.locale,
                merchant: config.merchant,
                limit: config.limit,
                cursor: config.cursor,
                filters: config.filters,
                session_id: config.session_id, // Look into this and apply it if needed
                sort: config.sort
            }
        )
    return match(request)
        .with({ success: true }, async data => {
            // Transform the raw data
            const transformedData = transformDepictProductData(data)
            if (
                Array.isArray(transformedData.displays) &&
                transformedData.displays.length === 0
            ) {
                return transformedData // Return unchanged if "displays" is missing
            }
            const transformedDataWithFormattedPrices = formatPricesInTransformedData(
                transformedData,
                currentPricelist
            )
            return transformedDataWithFormattedPrices
        })
        .with({ success: false }, ({ error }) => {
            logger.error(
                "Failed resposne fetching products via 'getProductsInListingViaExternalId' from Depict",
                error
            )
            return []
        })
        .exhaustive()
}
